import api from '@/lib/api';
import type { MappableProfileField } from '@hygge/shared';
import { CACHE_TIME } from '@hygge/shared';
import { useQuery } from '@tanstack/react-query';

export const mappableProfileFieldsKeys = {
  all: ['mappable-profile-fields'] as const,
};

async function listMappableFields(): Promise<MappableProfileField[]> {
  const { data } = await api.get<MappableProfileField[]>(
    '/employee-profile-fields/mappable',
  );
  return data;
}

/**
 * The catalog of Employee profile attributes a pre-boarding form field can map
 * to (HW-563). Used by the Step 3 builder's mapping picker.
 */
export function useMappableProfileFields() {
  return useQuery({
    queryKey: mappableProfileFieldsKeys.all,
    queryFn: listMappableFields,
    staleTime: CACHE_TIME.DEFAULT,
  });
}
